var styles = {
  "dialogWrapper": "pb-ModalDialog__dialogWrapper",
  "drawerWrapper": "pb-ModalDialog__drawerWrapper",
  "dialog": "pb-ModalDialog__dialog",
  "drawer": "pb-ModalDialog__drawer",
  "header": "pb-ModalDialog__header",
  "closeButton": "pb-ModalDialog__closeButton",
  "content": "pb-ModalDialog__content",
  "underlay": "pb-ModalDialog__underlay",
  "enter": "pb-ModalDialog__enter",
  "exit": "pb-ModalDialog__exit",
  "open": "pb-ModalDialog__open"
};
export default styles;